// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"1112e3a7","702":"0b76ab89"}[chunkId] + ".chunk.js";
};